module.exports = __webpack_public_path__ + "img/Profil_VP-Ultraline_Standard.8242289a.jpg";